module.exports = __webpack_public_path__ + "teqbahn-assets/media/HowWeDoBg.b4c1af24.png";